import React from 'react';
import { Select, Spin, Button, Icon, Modal, Form, Input, Row, Col, InputNumber } from 'antd';
import { openNotification } from '../../util/notificaciones';
import ArticulosRequest from '../../services/Articulos';
import SustitucionDemandaRequest from '../../services/SustitucionDemanda';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;
const { Search } = Input;

/**
 * Clase para ver el proceso de formulario de categorizar
 */
class FormSustitucionDemanda extends BaseComponent {
    state = {
        arrCategorias: [],
        arrArticulosBusquedaOld: [],
        arrArticulosBusquedaNew: [],
        guardando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrTiposModelos: [],
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.sustitucion_selected !== prevProps.sustitucion_selected) {
            if (this.props.sustitucion_selected) {
                if (this.props.modo === 'editar') {
                    state.arrArticulosBusquedaOld.push(this.props.sustitucion_selected.articulo_anterior);
                    state.arrArticulosBusquedaNew.push(this.props.sustitucion_selected.articulo_nuevo);
                    this.setState(state, () => {
                        const { setFieldsValue } = this.props.form
                        setFieldsValue({
                            articulo_anterior: this.props?.sustitucion_selected?.articulo_anterior?.id ?? null,
                            articulo_nuevo: this.props?.sustitucion_selected?.articulo_nuevo?.id ?? null
                        })
                    })
                }

            }
        }
    }

    /**
     * Comportamiento al hacer clic en guardar una sustitución
     * @param: nada.
     * @return: nada.
     */
    editarSustitucion = () => {
        let state = { ...this.state }
        let objEnviar = {}
        objEnviar.articulo_anterior = {}
        objEnviar.articulo_nuevo = {}
        this.props.form.validateFields((err, values) => {
            if (!err) {
                objEnviar.id = this.props.sustitucion_selected?.id ?? null
                objEnviar.articulo_anterior.id = values.articulo_anterior
                objEnviar.articulo_nuevo.id = values.articulo_nuevo
                objEnviar.factor = values.factor
                objEnviar.sitio = this.props.drive_selected
                let ruta = this.props.type === 'dos' ? SustitucionDemandaRequest.NuevaSustitucionDemanda(objEnviar) : SustitucionDemandaRequest.EditarSustitucionDemanda(objEnviar)
                this.setState({ guardando: true, bloquearBotones: true }, () => {
                    ruta
                        .then(response => {
                            state.guardando = false;
                            state.bloquearBotones = false;
                            state.arrArticulosBusquedaOld = []
                            state.arrArticulosBusquedaNew = []
                            this.props.form.resetFields();
                            this.props.esconderModal(true);
                            this.setState(state)
                            openNotification(
                                response?.data?.cuerpo,
                                response?.data?.titulo,
                                true
                            )
                        })
                        .catch(err => {
                            this.setState({ guardando: false, bloquearBotones: false })
                            if(err?.response?.data?.error) {
                                this.props.mostrarErrores(err?.response?.data.error)
                            } else {
                                openNotification(
                                    err?.response?.data?.cuerpo,
                                    err?.response?.data?.titulo,
                                    false
                                )
                            }
                            
                        })
                })

            }
        })
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);
        this.setState({ bloquearBotones: false, arrArticulosBusquedaNew: [], arrArticulosBusquedaOld: [] })
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.props.type === 'uno') {
                    confirm({
                        title: 'Confirmar',
                        content: <div><b>¿Está seguro de editar la sustitución?</b> Se cambiará la información de los artículos y su factor.</div>,
                        okText: 'Aceptar',
                        cancelText: 'Cancelar',
                        okButtonProps: {
                            id: 'boton-aceptar-confirmacion-sustitucion-form',
                        },
                        cancelButtonProps: {
                            id: 'boton-cancelar-confirmacion-sustitucion-form',
                        },
                        onOk: () => {
                            this.setState({ guardando: true, bloquearBotones: true }, this.editarSustitucion())
                        },
                    });
                } else {
                    this.setState({ guardando: true, bloquearBotones: true }, this.editarSustitucion())
                }
            }
        })
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en buscar en input search
     * @param: value. valor del input search
     * @param: boolean. identifica si es artículo nuevo o anterior
     * @return: nada.
     */
    buscarArticulo = (value, boolean) => {
        let state = { ...this.state }
        let filtros = {}
        if (value.trim()) {
            filtros.filtro = value
            const { setFieldsValue } = this.props.form
            if (boolean) {
                setFieldsValue({
                    articulo_nuevo: null
                })
            } else {
                setFieldsValue({
                    articulo_anterior: null
                })
            }

            this.setState({ cargando: true }, () => {
                ArticulosRequest.ListarArticulos(filtros)
                    .then(response => {
                        if (boolean) {
                            state.arrArticulosBusquedaNew = response.data.results
                        } else {

                            state.arrArticulosBusquedaOld = response.data.results
                        }
                        state.cargando = false;
                        this.setState(state)
                        if (!response.data.results.length) openNotification(
                            "No se ha encontrado un artículo con el código / descripción ingresado.",
                            "Verificar búsqueda",
                            false
                        )
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(err?.response?.data?.cuerpo, err?.response?.data?.cuerpo, false)
                    })
            })
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let modo = this.props.modo
        return (
            <div>
                <Modal
                    title={this.props.modo === 'ver' ? 'Ver detalle de sustitución' : this.props.modo === 'editar' ? 'Editar sustitución' : 'Nueva sustitución'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.categorizarArts}
                    width={this.state.isPos ? "95%" : "65%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-equivalencia-form"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-equivalencia-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col className={this.props.modo === 'ver' ? 'display-none' : ''} span={12}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Buscar artículo por Código / Descripción</b> : 'Buscar artículo por Código / Descripción'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('buscar_articulo_old', {
                                            rules: [
                                                { required: false },
                                                { whitespace: true, message: 'Por favor, ingrese Código / Descripción.' }
                                            ]
                                        })(
                                            <Search
                                                className={modo !== 'ver' ? 'btn-buscar-articulo-form' : 'disableInputText'}
                                                disabled={modo !== 'ver' ? false : true}
                                                id="input-search-articulo-sustitucion-form-old"
                                                placeholder="Ingrese Código / Descripción"
                                                enterButton="Buscar"
                                                onSearch={value => { this.buscarArticulo(value, false) }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Artículo anterior</b> : 'Artículo anterior'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('articulo_anterior', {
                                            rules: [
                                                { required: modo !== 'ver' ? true : false, message: 'Por favor, seleccione un artículo.' },
                                            ],
                                            initialValue: (
                                                this.props?.sustitucion_selected?.articulo_anterior?.id
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-articulo-form-sustitucion-old"
                                                className={(modo === 'ver' || !this.state.arrArticulosBusquedaOld?.length) ? 'disableInputText' : ''}
                                                disabled={(modo === 'ver' || !this.state.arrArticulosBusquedaOld?.length) ? true : false}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={modo !== 'ver'}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrArticulosBusquedaOld?.length > 0 &&
                                                    this.state.arrArticulosBusquedaOld?.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj?.id}
                                                                value={obj?.id}>
                                                                {obj?.codigo_descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.props.modo === 'ver' ? 'display-none' : ''} span={12}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Buscar artículo por Código / Descripción</b> : 'Buscar artículo por Código / Descripción'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('buscar_articulo_new', {
                                            rules: [
                                                { required: false },
                                                { whitespace: true, message: 'Por favor, ingrese Código / Descripción.' }
                                            ]
                                        })(
                                            <Search
                                                className={modo !== 'ver' ? 'btn-buscar-articulo-form' : 'disableInputText'}
                                                disabled={modo !== 'ver' ? false : true}
                                                id="input-search-articulo-sustitucion-new-form"
                                                placeholder="Ingrese Código / Descripción"
                                                enterButton="Buscar"
                                                onSearch={value => { this.buscarArticulo(value, true) }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Artículo nuevo</b> : 'Artículo nuevo'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('articulo_nuevo', {
                                            rules: [
                                                { required: modo !== 'ver' ? true : false, message: 'Por favor, seleccione un artículo.' },
                                            ],
                                            initialValue: (
                                                this.props?.sustitucion_selected?.articulo_nuevo?.id
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-articulo-form-sustitucion-new"
                                                className={(modo === 'ver' || !this.state.arrArticulosBusquedaNew?.length) ? 'disableInputText' : ''}
                                                disabled={(modo === 'ver' || !this.state.arrArticulosBusquedaNew?.length) ? true : false}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={modo !== 'ver'}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrArticulosBusquedaNew?.length > 0 &&
                                                    this.state.arrArticulosBusquedaNew?.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj?.id}
                                                                value={obj?.id}>
                                                                {obj?.codigo_descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Factor</b> : 'Factor'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('factor', {
                                            rules: [
                                                { required: modo !== 'ver' ? true : false, message: 'Por favor, ingrese una cantidad para factor' }
                                            ],
                                            initialValue: (
                                                this.props?.sustitucion_selected?.factor_conversion
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-factor-sustitucion-form"
                                                type="number"
                                                className={modo === 'ver' ? 'disableInputText' : ''}
                                                disabled={(modo === 'ver') ? true : false}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                precision={4}
                                                min={0}
                                                maxLength={5}
                                                max={10000}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormSustitucionDemanda);